import { render, staticRenderFns } from "./CheckoutItem.vue?vue&type=template&id=fbb821be"
import script from "./CheckoutItem.vue?vue&type=script&lang=js"
export * from "./CheckoutItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CheckoutItem.vue"
export default component.exports